import source from "@/messages/primary-service-nav-source.json";
import labels from "@/messages/mandarin-primary-service-nav.json";
import type { PrimaryServiceNavLink } from "@/app/components/primary-service-nav";
/** Source identity only. Draft wording is not publication or accuracy approval. */
export function mandarinPrimaryServiceNav(
  current: readonly PrimaryServiceNavLink[]
): PrimaryServiceNavLink[] {
  if (JSON.stringify(current) !== JSON.stringify(source))
    throw new Error("Stale Mandarin primary service navigation");
  function translate(value: string): string {
    if (!(value in labels))
      throw new Error(`Missing Mandarin navigation label: ${value}`);
    return labels[value as keyof typeof labels];
  }
  return current.map((item) => ({
    ...item,
    label: translate(item.label),
    children: item.children?.map((child) => ({
      ...child,
      label: translate(child.label),
      shortLabel: child.shortLabel ? translate(child.shortLabel) : undefined,
    })),
    childColumns: item.childColumns?.map((column) => ({
      ...column,
      heading: column.heading ? translate(column.heading) : undefined,
      links: column.links.map((child) => ({
        ...child,
        label: translate(child.label),
        shortLabel: child.shortLabel ? translate(child.shortLabel) : undefined,
      })),
    })),
  }));
}
